import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CriteriaSearch} from 'src/app/domain/search/CriteriaSearch';
import {Pagination} from 'src/app/domain/search/Pagination';
import {SearchObject} from 'src/app/domain/search/SearchObject';
import {SharedWsService} from 'src/app/modules/services/Common/shared-ws.service';
import {NewsService} from 'src/app/modules/services/news/news.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {constantePortail} from '../../../../domain/portail/portail-result';
import {
    DialogListAttachFilesComponent
} from '../../../content-layout/pages/acheteur/appel-offre/proc-passa/ouverture-offres/dialog-list-attach-files/dialog-list-attach-files.component';
import {MatDialog} from '@angular/material/dialog';
import {Location} from '@angular/common';

@Component({
    selector: 'app-admin-announcement-card',
    templateUrl: './admin-announcement-card.component.html',
    styleUrls: ['./admin-announcement-card.component.css']
})
export class AdminAnnouncementCardComponent implements OnInit {
    cardDetailAnnonces = constantePortail.cardDetailAnnoncesService;
    @ViewChild('contentContainer') contentContainer: ElementRef;

    public id = null;
    public item: any;
    public searchObject = new SearchObject();
    public pagination: Pagination = new Pagination();
    public fileitems: any[];
    public criteriaSearch: CriteriaSearch = new CriteriaSearch('fileClCd', '02', '=');
    public dataSearch: Array<CriteriaSearch> = [];
    criteriaSearch2: CriteriaSearch;

    constructor(
        private route: ActivatedRoute,
        private newsService: NewsService,
        public translate: AppTranslateService,
        private sharedWsService: SharedWsService,
        private dialog: MatDialog,
        private _location: Location,
    ) {
    }

    ngOnInit(): void {
        this.id = this.route.snapshot.params.id;
        // this.route.queryParams.subscribe(params => {
        //   this.id = params.id;
        // });
        this.initAnnonceDetails();
    }

    _getContent = (data) => {
        switch (this.translate.getDefaultLang()) {
            case 'ar':
                return data['cont2'];
            case 'fr':
                return data['cont1'];
            case 'en':
                return data['contEn'];
        }
    };

    initAnnonceDetails() {
        this.newsService.loadcardAdmin(this.id)
            .subscribe(response => {
                this.item = response['payload'];
                this.contentContainer.nativeElement.innerHTML = this._getContent(this.item);
            });
    }


    // downloadFile(noderef: string, name: string, filePath: string) {
    //   //this.newsService.download(noderef, name);
    //   this.sharedWsService.downloadFile(noderef, filePath, name);
    // }

    openDialogListAttachFiles(data) {
        this.dialog.open(DialogListAttachFilesComponent, {
            disableClose: true,
            width: '90rem',
            direction: this.translate.getDir(),
            data: {
                dialogTitle: 'Pièces jointes',
                cardTitle: 'Liste pièces jointes',
                bidInfos: {
                    ...data.element,
                    code: data.code,
                },
            },
        });
    }

    onPrecedent() {
        this._location.back();
    }


}
